import { Button } from "antd";
import { useViewerStore } from '../../../../../store/store';

interface FlipAllBallastConfirmProps {
    onConfirm: () => void;
}

const FlipAllBallastConfirm = ({ onConfirm }: FlipAllBallastConfirmProps) => {
    const { sceneViewer } = useViewerStore();
    const confirmFlip = () => {
        onConfirm();
        sceneViewer.viewerAlert({ show: false });
    };
    const cancel = () => sceneViewer.viewerAlert({ show: false });

    return (
        <>
            <p>No Ballasted Racks selected.All ballasted modules will be flipped.Click Confirm to proceed.</p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>
                <Button
                    id={"confirmFlipAllBallastBtn"}
                    type="primary"
                    size="large"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirmFlip}
                >
                    Confirm
                </Button>
                <Button
                    type="primary"
                    size="large"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancel}
                >
                    Cancel
                </Button>
            </div>
        </>
    );
};

export default FlipAllBallastConfirm;
